var _defs, _g, _g2, _path, _path2, _path3, _rect, _g3, _text, _text2, _g4, _text3, _circle, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollect1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 524.369,
    height: 572.927,
    viewBox: "0 0 524.369 572.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23603",
    "data-name": "Path 23603",
    d: "M-83.66,0h36.339V24.048H-83.66Z",
    transform: "translate(83.66)",
    fill: "rgba(0,0,0,0.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23608",
    "data-name": "Path 23608",
    d: "M0,0H34.931V26.2H0Z",
    fill: "rgba(0,0,0,0.7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14576",
    "data-name": "Group 14576",
    transform: "translate(-1123 -5960.858)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14220",
    "data-name": "Group 14220",
    transform: "translate(1123 5960.858)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2566",
    "data-name": "Ellipse 2566",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2643",
    "data-name": "Ellipse 2643",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2567",
    "data-name": "Ellipse 2567",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2629",
    "data-name": "Ellipse 2629",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2568",
    "data-name": "Ellipse 2568",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2644",
    "data-name": "Ellipse 2644",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2569",
    "data-name": "Ellipse 2569",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2630",
    "data-name": "Ellipse 2630",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2570",
    "data-name": "Ellipse 2570",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2670",
    "data-name": "Ellipse 2670",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2571",
    "data-name": "Ellipse 2571",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2672",
    "data-name": "Ellipse 2672",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2572",
    "data-name": "Ellipse 2572",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2573",
    "data-name": "Ellipse 2573",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2561",
    "data-name": "Ellipse 2561",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2574",
    "data-name": "Ellipse 2574",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2575",
    "data-name": "Ellipse 2575",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2641",
    "data-name": "Ellipse 2641",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2576",
    "data-name": "Ellipse 2576",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2631",
    "data-name": "Ellipse 2631",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2577",
    "data-name": "Ellipse 2577",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2642",
    "data-name": "Ellipse 2642",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2578",
    "data-name": "Ellipse 2578",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2632",
    "data-name": "Ellipse 2632",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2579",
    "data-name": "Ellipse 2579",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2674",
    "data-name": "Ellipse 2674",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2580",
    "data-name": "Ellipse 2580",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2676",
    "data-name": "Ellipse 2676",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2581",
    "data-name": "Ellipse 2581",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2582",
    "data-name": "Ellipse 2582",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2562",
    "data-name": "Ellipse 2562",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2583",
    "data-name": "Ellipse 2583",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2584",
    "data-name": "Ellipse 2584",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2633",
    "data-name": "Ellipse 2633",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2585",
    "data-name": "Ellipse 2585",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2623",
    "data-name": "Ellipse 2623",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2586",
    "data-name": "Ellipse 2586",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2634",
    "data-name": "Ellipse 2634",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2587",
    "data-name": "Ellipse 2587",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2624",
    "data-name": "Ellipse 2624",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2588",
    "data-name": "Ellipse 2588",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2678",
    "data-name": "Ellipse 2678",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2589",
    "data-name": "Ellipse 2589",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2680",
    "data-name": "Ellipse 2680",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2590",
    "data-name": "Ellipse 2590",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2591",
    "data-name": "Ellipse 2591",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2563",
    "data-name": "Ellipse 2563",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2592",
    "data-name": "Ellipse 2592",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2593",
    "data-name": "Ellipse 2593",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2635",
    "data-name": "Ellipse 2635",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2594",
    "data-name": "Ellipse 2594",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2625",
    "data-name": "Ellipse 2625",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2595",
    "data-name": "Ellipse 2595",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2636",
    "data-name": "Ellipse 2636",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2596",
    "data-name": "Ellipse 2596",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2626",
    "data-name": "Ellipse 2626",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2597",
    "data-name": "Ellipse 2597",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2682",
    "data-name": "Ellipse 2682",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2598",
    "data-name": "Ellipse 2598",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2684",
    "data-name": "Ellipse 2684",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2599",
    "data-name": "Ellipse 2599",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2600",
    "data-name": "Ellipse 2600",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2564",
    "data-name": "Ellipse 2564",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2601",
    "data-name": "Ellipse 2601",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2602",
    "data-name": "Ellipse 2602",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2637",
    "data-name": "Ellipse 2637",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2603",
    "data-name": "Ellipse 2603",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2621",
    "data-name": "Ellipse 2621",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2604",
    "data-name": "Ellipse 2604",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2638",
    "data-name": "Ellipse 2638",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2605",
    "data-name": "Ellipse 2605",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2627",
    "data-name": "Ellipse 2627",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2606",
    "data-name": "Ellipse 2606",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2686",
    "data-name": "Ellipse 2686",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2688",
    "data-name": "Ellipse 2688",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2608",
    "data-name": "Ellipse 2608",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2609",
    "data-name": "Ellipse 2609",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2565",
    "data-name": "Ellipse 2565",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2610",
    "data-name": "Ellipse 2610",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2611",
    "data-name": "Ellipse 2611",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2639",
    "data-name": "Ellipse 2639",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2556",
    "data-name": "Ellipse 2556",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2653",
    "data-name": "Ellipse 2653",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2612",
    "data-name": "Ellipse 2612",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2622",
    "data-name": "Ellipse 2622",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2613",
    "data-name": "Ellipse 2613",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2640",
    "data-name": "Ellipse 2640",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2557",
    "data-name": "Ellipse 2557",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2654",
    "data-name": "Ellipse 2654",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2614",
    "data-name": "Ellipse 2614",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2628",
    "data-name": "Ellipse 2628",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2615",
    "data-name": "Ellipse 2615",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2690",
    "data-name": "Ellipse 2690",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2558",
    "data-name": "Ellipse 2558",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2691",
    "data-name": "Ellipse 2691",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2616",
    "data-name": "Ellipse 2616",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(64.172 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2692",
    "data-name": "Ellipse 2692",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2617",
    "data-name": "Ellipse 2617",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2559",
    "data-name": "Ellipse 2559",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2618",
    "data-name": "Ellipse 2618",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.136 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2619",
    "data-name": "Ellipse 2619",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2560",
    "data-name": "Ellipse 2560",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2620",
    "data-name": "Ellipse 2620",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.188 153.36)",
    fill: "#090909"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14221",
    "data-name": "Group 14221",
    transform: "translate(1372.685 6334.3)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2566-2",
    "data-name": "Ellipse 2566",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3060",
    "data-name": "Ellipse 3060",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2643-2",
    "data-name": "Ellipse 2643",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3061",
    "data-name": "Ellipse 3061",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2567-2",
    "data-name": "Ellipse 2567",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3014",
    "data-name": "Ellipse 3014",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2629-2",
    "data-name": "Ellipse 2629",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3015",
    "data-name": "Ellipse 3015",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2568-2",
    "data-name": "Ellipse 2568",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3062",
    "data-name": "Ellipse 3062",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2644-2",
    "data-name": "Ellipse 2644",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3063",
    "data-name": "Ellipse 3063",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2569-2",
    "data-name": "Ellipse 2569",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3016",
    "data-name": "Ellipse 3016",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2630-2",
    "data-name": "Ellipse 2630",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3017",
    "data-name": "Ellipse 3017",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2670-2",
    "data-name": "Ellipse 2670",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3064",
    "data-name": "Ellipse 3064",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 11.964)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2672-2",
    "data-name": "Ellipse 2672",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3018",
    "data-name": "Ellipse 3018",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 89.188)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2575-2",
    "data-name": "Ellipse 2575",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3019",
    "data-name": "Ellipse 3019",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2641-2",
    "data-name": "Ellipse 2641",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3020",
    "data-name": "Ellipse 3020",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2576-2",
    "data-name": "Ellipse 2576",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3021",
    "data-name": "Ellipse 3021",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2631-2",
    "data-name": "Ellipse 2631",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3022",
    "data-name": "Ellipse 3022",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2577-2",
    "data-name": "Ellipse 2577",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3023",
    "data-name": "Ellipse 3023",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2642-2",
    "data-name": "Ellipse 2642",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3024",
    "data-name": "Ellipse 3024",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2578-2",
    "data-name": "Ellipse 2578",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3025",
    "data-name": "Ellipse 3025",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2632-2",
    "data-name": "Ellipse 2632",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3026",
    "data-name": "Ellipse 3026",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2674-2",
    "data-name": "Ellipse 2674",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3027",
    "data-name": "Ellipse 3027",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 25.016)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2676-2",
    "data-name": "Ellipse 2676",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3028",
    "data-name": "Ellipse 3028",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 102.24)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2584-2",
    "data-name": "Ellipse 2584",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3029",
    "data-name": "Ellipse 3029",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2633-2",
    "data-name": "Ellipse 2633",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3030",
    "data-name": "Ellipse 3030",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2585-2",
    "data-name": "Ellipse 2585",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3031",
    "data-name": "Ellipse 3031",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2623-2",
    "data-name": "Ellipse 2623",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3032",
    "data-name": "Ellipse 3032",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2586-2",
    "data-name": "Ellipse 2586",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3033",
    "data-name": "Ellipse 3033",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2634-2",
    "data-name": "Ellipse 2634",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3034",
    "data-name": "Ellipse 3034",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2587-2",
    "data-name": "Ellipse 2587",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3035",
    "data-name": "Ellipse 3035",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2624-2",
    "data-name": "Ellipse 2624",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3036",
    "data-name": "Ellipse 3036",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2678-2",
    "data-name": "Ellipse 2678",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3037",
    "data-name": "Ellipse 3037",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 38.068)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2680-2",
    "data-name": "Ellipse 2680",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3038",
    "data-name": "Ellipse 3038",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 115.292)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2593-2",
    "data-name": "Ellipse 2593",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3039",
    "data-name": "Ellipse 3039",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2635-2",
    "data-name": "Ellipse 2635",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3040",
    "data-name": "Ellipse 3040",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2594-2",
    "data-name": "Ellipse 2594",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3041",
    "data-name": "Ellipse 3041",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2625-2",
    "data-name": "Ellipse 2625",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3005",
    "data-name": "Ellipse 3005",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2595-2",
    "data-name": "Ellipse 2595",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3042",
    "data-name": "Ellipse 3042",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2636-2",
    "data-name": "Ellipse 2636",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3043",
    "data-name": "Ellipse 3043",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2596-2",
    "data-name": "Ellipse 2596",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3044",
    "data-name": "Ellipse 3044",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2626-2",
    "data-name": "Ellipse 2626",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3006",
    "data-name": "Ellipse 3006",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2682-2",
    "data-name": "Ellipse 2682",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3045",
    "data-name": "Ellipse 3045",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 50.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2684-2",
    "data-name": "Ellipse 2684",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3007",
    "data-name": "Ellipse 3007",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 127.256)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2602-2",
    "data-name": "Ellipse 2602",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3046",
    "data-name": "Ellipse 3046",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2637-2",
    "data-name": "Ellipse 2637",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3047",
    "data-name": "Ellipse 3047",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2603-2",
    "data-name": "Ellipse 2603",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3048",
    "data-name": "Ellipse 3048",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2621-2",
    "data-name": "Ellipse 2621",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3008",
    "data-name": "Ellipse 3008",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2604-2",
    "data-name": "Ellipse 2604",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3049",
    "data-name": "Ellipse 3049",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2638-2",
    "data-name": "Ellipse 2638",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3050",
    "data-name": "Ellipse 3050",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2605-2",
    "data-name": "Ellipse 2605",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3051",
    "data-name": "Ellipse 3051",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2627-2",
    "data-name": "Ellipse 2627",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3009",
    "data-name": "Ellipse 3009",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2686-2",
    "data-name": "Ellipse 2686",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3052",
    "data-name": "Ellipse 3052",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 63.084)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2688-2",
    "data-name": "Ellipse 2688",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3010",
    "data-name": "Ellipse 3010",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 140.308)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2611-2",
    "data-name": "Ellipse 2611",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3053",
    "data-name": "Ellipse 3053",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2639-2",
    "data-name": "Ellipse 2639",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3054",
    "data-name": "Ellipse 3054",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2556-2",
    "data-name": "Ellipse 2556",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3065",
    "data-name": "Ellipse 3065",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2653-2",
    "data-name": "Ellipse 2653",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3066",
    "data-name": "Ellipse 3066",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2612-2",
    "data-name": "Ellipse 2612",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(101.059 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3055",
    "data-name": "Ellipse 3055",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(38.068 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2622-2",
    "data-name": "Ellipse 2622",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(62.991 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3011",
    "data-name": "Ellipse 3011",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(0 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2613-2",
    "data-name": "Ellipse 2613",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3056",
    "data-name": "Ellipse 3056",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2640-2",
    "data-name": "Ellipse 2640",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3057",
    "data-name": "Ellipse 3057",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2557-2",
    "data-name": "Ellipse 2557",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3067",
    "data-name": "Ellipse 3067",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2654-2",
    "data-name": "Ellipse 2654",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3068",
    "data-name": "Ellipse 3068",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2614-2",
    "data-name": "Ellipse 2614",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(114.111 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3058",
    "data-name": "Ellipse 3058",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(51.12 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2628-2",
    "data-name": "Ellipse 2628",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(76.043 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3012",
    "data-name": "Ellipse 3012",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(13.052 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2690-2",
    "data-name": "Ellipse 2690",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3059",
    "data-name": "Ellipse 3059",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 76.136)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2691-2",
    "data-name": "Ellipse 2691",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3069",
    "data-name": "Ellipse 3069",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2692-2",
    "data-name": "Ellipse 2692",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(89.095 153.36)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3013",
    "data-name": "Ellipse 3013",
    cx: 2.175,
    cy: 2.175,
    rx: 2.175,
    ry: 2.175,
    transform: "translate(26.104 153.36)",
    fill: "#090909"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14222",
    "data-name": "Group 14222",
    transform: "translate(1157.633 6004.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8434",
    "data-name": "Group 8434",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M995.1,446.744l-426.082,1.141c-17.39.047-31.448,13.849-31.4,30.83l.679,241.7c.048,16.98,14.184,30.707,31.573,30.66l426.083-1.141c17.39-.047,31.448-13.85,31.4-30.83l-.679-241.7C1026.626,460.424,1012.49,446.7,995.1,446.744Z",
    transform: "translate(-537.617 -446.744)",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M1119.855,446.744l-197.133.541a151.65,151.65,0,0,0,9.232,47.195c26.991,72.727,111.563,121.951,219.145,134.267l-.415-151.342A30.745,30.745,0,0,0,1119.855,446.744Z",
    transform: "translate(-661.612 -446.744)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M538.024,575.343l.1,35.179L728.112,447.829l-41.311.113Z",
    transform: "translate(-537.76 -447.126)",
    fill: "#12a15a",
    opacity: 0.2,
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M1060.033,446.722a263.725,263.725,0,0,1-15.564,90.59c-33.309,91.7-109.563,136.47-149.344,159.827C844.076,727.11,790.646,742.942,739.8,750.1l316.48-.868a29.979,29.979,0,0,0,29.9-30.06l-.678-247.127A25.4,25.4,0,0,0,1060.033,446.722Z",
    transform: "translate(-597.233 -446.04)",
    fill: "#12a15a",
    opacity: 0.18
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3056",
    "data-name": "Rectangle 3056",
    width: 66.207,
    height: 66.207,
    rx: 27,
    transform: "translate(37.044 25.529)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(53.225 47.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 34.383,
    height: 21.268,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.741)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 34.383,
    height: 2.741,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 34.383,
    height: 2.741,
    transform: "translate(0 5.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 34.383,
    height: 2.741,
    transform: "translate(0 10.524)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 34.383,
    height: 2.741,
    transform: "translate(0 18.527)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 34.383,
    height: 2.741,
    transform: "translate(0 15.786)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 17.724,
    height: 12.725,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.8 2.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.572,160.624l-.285.878h-.923l.747.542-.285.878.747-.542.747.542-.285-.878.747-.542h-.923Z",
    transform: "translate(-78.461 -157.455)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.857,207.275l-.285-.878-.285.878h-.923l.747.543-.285.878.747-.542.747.542-.285-.878.747-.543Z",
    transform: "translate(-78.461 -200.059)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.495,207.275l-.285-.878-.285.878H26l.747.543-.285.878.747-.542.747.542-.285-.878.747-.543Z",
    transform: "translate(-26.001 -200.059)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M27.21,160.624l-.285.878H26l.747.542-.285.878.747-.542.747.542-.285-.878.747-.542h-.923Z",
    transform: "translate(-26.001 -157.455)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.572,114.85l-.285.878h-.923l.747.542-.285.878.747-.543.747.543-.285-.878.747-.542h-.923Z",
    transform: "translate(-78.461 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M27.21,114.85l-.285.878H26l.747.542-.285.878.747-.543.747.543-.285-.878.747-.542h-.923Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.934,160.624l-.285.878h-.923l.747.542-.285.878.747-.542.747.542-.285-.878.747-.542h-.923Z",
    transform: "translate(-130.921 -157.455)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M140.219,207.275l-.285-.878-.285.878h-.923l.747.543-.285.878.747-.542.747.542-.285-.878.747-.543Z",
    transform: "translate(-130.921 -200.059)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.582,207.275l-.285-.878-.285.878h-.923l.747.543-.285.878.747-.542.747.542-.285-.878.747-.543Z",
    transform: "translate(-183.381 -200.059)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.3,160.624l-.285.878h-.923l.747.542-.285.878.747-.542.747.542-.285-.878.747-.542h-.923Z",
    transform: "translate(-183.381 -157.455)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.934,114.85l-.285.878h-.923l.747.542-.285.878.747-.543.747.543-.285-.878.747-.542h-.923Z",
    transform: "translate(-130.921 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.3,114.85l-.285.878h-.923l.747.542-.285.878.747-.543.747.543-.285-.878.747-.542h-.923Z",
    transform: "translate(-183.381 -114.85)",
    fill: "#f0f0f0"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_2_52_343.00",
    "data-name": "$2,52,343.00",
    transform: "translate(37.657 177.111)",
    fill: "#fff",
    fontSize: 35,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$2,52,343.00"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "My_balance",
    "data-name": "My balance",
    transform: "translate(37.657 125.825)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "My balance"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8444",
    "data-name": "Group 8444",
    transform: "translate(37.657 232.001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "USD_account",
    "data-name": "USD account",
    transform: "translate(0 18)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD account")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M19.556,11.566a1.083,1.083,0,0,1,1.536,0,1.1,1.1,0,0,1,0,1.541l-6.521,6.526a1.086,1.086,0,0,1-1.5.032L6.5,13.111A1.088,1.088,0,1,1,8.041,11.57Z",
    transform: "translate(123.984 -0.547)",
    fill: "#61ce65"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "USD",
    transform: "translate(398.975 269.358)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.07em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 8.237,
    cy: 8.237,
    r: 8.237,
    transform: "translate(320.615 178.832)",
    fill: "#12a15a",
    opacity: 0.39
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8445",
    "data-name": "Group 8445",
    transform: "translate(462.278 21.771)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2.746,
    cy: 2.746,
    rx: 2.746,
    ry: 2.746,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2.746,
    cy: 2.746,
    rx: 2.746,
    ry: 2.746,
    transform: "translate(0 9.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2.746,
    cy: 2.746,
    rx: 2.746,
    ry: 2.746,
    transform: "translate(0 19.77)",
    fill: "#fff"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14223",
    "data-name": "Group 14223",
    transform: "translate(1191.408 6272.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.769,
    height: 261.057,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 154.769,
    height: 260.057,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGD_EUR_GBP_JPY_HKD",
    "data-name": "SGD EUR GBP JPY HKD",
    transform: "translate(28.846 43.961)",
    fill: "#111",
    fontSize: 17,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SGD"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 46
  }, "EUR"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 92
  }, "GBP"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 138
  }, "JPY"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 184
  }, "HKD")), /*#__PURE__*/React.createElement("g", {
    id: "_109-united_kingdom",
    "data-name": "109-united kingdom",
    transform: "translate(90.092 121.705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 34.457,
    height: 22.971,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M19.382,85.33H15.075v9.332H0v4.307H15.075V108.3h4.307V98.969H34.457V94.662H19.382Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(20.974 15.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M393.785,315.358l7.956,4.42v-4.42Z",
    transform: "translate(-388.258 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M311.652,315.358l13.483,7.491V320.73l-9.67-5.372Z",
    transform: "translate(-311.652 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M321.544,350.494l-9.892-5.5v5.5Z",
    transform: "translate(-311.652 -343.003)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M311.652,315.358l13.483,7.491V320.73l-9.67-5.372Z",
    transform: "translate(-290.678 -299.878)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M311.652,315.358l13.483,7.491V320.73l-9.67-5.372Z",
    transform: "translate(-290.678 -299.878)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 15.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M6.08,315.356,0,318.734v-3.378Z",
    transform: "translate(0 -315.356)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M37.259,329.51v6.538H25.491Z",
    transform: "translate(-23.775 -328.557)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M9.67,315.358,0,320.73v2.118H0l13.483-7.491Z",
    transform: "translate(0 -299.878)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M7.956,135.378,0,130.958v4.42Z",
    transform: "translate(0 -127.887)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M13.483,92.821,0,85.33v2.118l9.67,5.372Z",
    transform: "translate(0 -85.33)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M53.366,85.33l9.892,5.5v-5.5Z",
    transform: "translate(-49.775 -85.33)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M13.483,92.821,0,85.33v2.118l9.67,5.372Z",
    transform: "translate(0 -85.33)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M13.483,92.821,0,85.33v2.118l9.67,5.372Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(20.974 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M421.659,149.824l6.08-3.378v3.378Z",
    transform: "translate(-414.256 -142.333)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M311.652,91.869V85.331H323.42Z",
    transform: "translate(-311.652 -85.331)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M315.465,92.821l9.67-5.372V85.33h0l-13.483,7.491Z",
    transform: "translate(-290.678 -85.33)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eu",
    transform: "translate(90.224 73.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M0,0H34.931V24.044H0Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425",
    transform: "translate(9.475 4.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(6.806 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-6.771-23.7l-.34,1.134.567.113Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    transform: "translate(6.806 13.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(0.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-6",
    "data-name": "a",
    d: "M-6.771-23.7l-.34,1.134.567.113Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-7",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-8",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-9",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-10",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(0 0.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    transform: "translate(0 6.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(0.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-11",
    "data-name": "a",
    d: "M-6.771-23.7l-.34,1.134.567.113Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-12",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-13",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-14",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-15",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 4.962, 3.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(0.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-16",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-4",
    "data-name": "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-17",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-18",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-19",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-20",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 3.772, 4.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(0.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-21",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-5",
    "data-name": "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-22",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-23",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-24",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-25",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    transform: "translate(2.862 9.47) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(0.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-26",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-6",
    "data-name": "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-27",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-28",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-29",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-30",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393",
    transform: "translate(5.324 11.753) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-7",
    "data-name": "b",
    transform: "translate(0.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-31",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-7",
    "data-name": "c",
    transform: "translate(0.842 0.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-32",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-33",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392",
    transform: "translate(1.526 2.252) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-34",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-35",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424",
    transform: "translate(15.981 15.199) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399",
    transform: "translate(0 6.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-8",
    "data-name": "b",
    transform: "translate(0.844 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-36",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-8",
    "data-name": "c",
    transform: "translate(0.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-37",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-38",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398",
    transform: "translate(1.526 1.792) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-39",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-40",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 6.286, 13.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-9",
    "data-name": "b",
    transform: "translate(0.844 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-41",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-9",
    "data-name": "c",
    transform: "translate(0.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-42",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-43",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404",
    transform: "translate(1.526 1.792) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-44",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-45",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.448, 12.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-10",
    "data-name": "b",
    transform: "translate(0.844 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-46",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-10",
    "data-name": "c",
    transform: "translate(0.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-47",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-48",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410",
    transform: "translate(1.526 1.792) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-49",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-50",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417",
    transform: "translate(0.72 4.535) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-11",
    "data-name": "b",
    transform: "translate(0.844 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-51",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-11",
    "data-name": "c",
    transform: "translate(0.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-52",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-53",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416",
    transform: "translate(1.526 1.792) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-54",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-55",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423",
    transform: "translate(3.182 2.252) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-12",
    "data-name": "b",
    transform: "translate(0.844 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-56",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-12",
    "data-name": "c",
    transform: "translate(0.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418",
    transform: "translate(0.129 1.406) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-57",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.551, 1.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-58",
    "data-name": "a",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422",
    transform: "translate(1.526 1.792) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420",
    transform: "translate(1.316 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-59",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.284, 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-60",
    "data-name": "a",
    d: "M.34,0,0,1.134l.567.113Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M.34,1.248,0,.113.567,0Z",
    transform: "translate(0.681 1.248) rotate(180)",
    fill: "#fc0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_240-japan",
    "data-name": "240-japan",
    transform: "translate(90.092 168.942)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 36.072,
    height: 24.048,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 6.764,
    cy: 6.764,
    rx: 6.764,
    ry: 6.764,
    transform: "translate(11.273 5.26)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hk",
    transform: "translate(90.092 215.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23582",
    "data-name": "Path 23582",
    d: "M-70.164,24.048H-106.6V0h36.433Z",
    transform: "translate(105.45)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23583",
    "data-name": "Path 23583",
    d: "M187.266,105.764a3.518,3.518,0,0,1-.07-6.421,7.239,7.239,0,0,1,1.55-.268,1.159,1.159,0,0,0-.315.423,1.012,1.012,0,0,0,.127.869,2.507,2.507,0,0,1,.348,1.108,1.719,1.719,0,0,1-.686,1.583c-.31.24-.676.324-.977.6a1.277,1.277,0,0,0-.423.85A1.652,1.652,0,0,0,187.266,105.764Z",
    transform: "translate(-171.724 -94.126)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23584",
    "data-name": "Path 23584",
    d: "M218.08,154.362v-.014",
    transform: "translate(-203.003 -146.636)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23585",
    "data-name": "Path 23585",
    d: "M208.017,158.261a2.971,2.971,0,0,1-.141-3.631",
    transform: "translate(-192.785 -146.904)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23586",
    "data-name": "Path 23586",
    d: "M218.672,137.282l.155.258-.282-.117-.221.235.038-.305-.282-.117.305-.07.038-.3.155.258.31-.07",
    transform: "translate(-203.003 -130.025)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23587",
    "data-name": "Path 23587",
    d: "M231.522,170.565a3.515,3.515,0,0,1,6.12-1.944,7.106,7.106,0,0,1,.7,1.4,1.113,1.113,0,0,0-.5-.174,1,1,0,0,0-.789.371,2.5,2.5,0,0,1-.958.658,1.719,1.719,0,0,1-1.714-.188c-.319-.23-.507-.554-.855-.761a1.325,1.325,0,0,0-.939-.16A1.665,1.665,0,0,0,231.522,170.565Z",
    transform: "translate(-215.773 -159.104)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23588",
    "data-name": "Path 23588",
    d: "M303.62,197.588h.014",
    transform: "translate(-284.269 -187.715)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23589",
    "data-name": "Path 23589",
    d: "M235,195.643a2.979,2.979,0,0,1,3.433-1.2",
    transform: "translate(-219.078 -184.559)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23590",
    "data-name": "Path 23590",
    d: "M307.46,194.979l-.2.221.028-.305-.282-.141.3-.047.028-.315.16.282.3-.056-.2.221.155.282",
    transform: "translate(-287.484 -184.679)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23591",
    "data-name": "Path 23591",
    d: "M235.094,232.031a3.519,3.519,0,0,1,3.79,5.185,7.3,7.3,0,0,1-1.1,1.118,1.109,1.109,0,0,0,0-.526.983.983,0,0,0-.6-.634,2.494,2.494,0,0,1-.93-.7,1.719,1.719,0,0,1-.362-1.681c.113-.376.362-.658.446-1.052a1.315,1.315,0,0,0-.146-.939A1.688,1.688,0,0,0,235.094,232.031Z",
    transform: "translate(-219.167 -220.383)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23592",
    "data-name": "Path 23592",
    d: "M288.11,291.494l.009.009",
    transform: "translate(-269.534 -276.929)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23593",
    "data-name": "Path 23593",
    d: "M243.46,234.06a2.984,2.984,0,0,1,2.226,2.879",
    transform: "translate(-227.115 -222.365)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23594",
    "data-name": "Path 23594",
    d: "M278.705,296.419l-.277-.122.305-.07.038-.315.146.268.305-.07-.211.235.141.268-.272-.122-.211.24",
    transform: "translate(-260.336 -281.126)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23595",
    "data-name": "Path 23595",
    d: "M133.232,238.389a3.518,3.518,0,0,1-3.912,5.091,7.314,7.314,0,0,1-1.386-.747,1.1,1.1,0,0,0,.512-.141,1,1,0,0,0,.437-.752,2.49,2.49,0,0,1,.413-1.094,1.719,1.719,0,0,1,1.512-.822c.395,0,.733.169,1.137.141a1.357,1.357,0,0,0,.864-.413,1.677,1.677,0,0,0,.423-1.268Z",
    transform: "translate(-117.361 -226.473)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23596",
    "data-name": "Path 23596",
    d: "M192.7,305.782l0,.009",
    transform: "translate(-178.891 -290.503)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23597",
    "data-name": "Path 23597",
    d: "M194.738,246.656a2.958,2.958,0,0,1-2.132,2.945",
    transform: "translate(-178.802 -234.331)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23598",
    "data-name": "Path 23598",
    d: "M171.855,300.161l.042-.3.155.268.31-.047-.216.216.155.268-.286-.136-.216.216.038-.3-.287-.136",
    transform: "translate(-158.798 -284.877)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23599",
    "data-name": "Path 23599",
    d: "M112.227,170.109a3.511,3.511,0,0,1-6.1-1.991,7.2,7.2,0,0,1,.24-1.55,1.2,1.2,0,0,0,.305.432,1.014,1.014,0,0,0,.86.16,2.442,2.442,0,0,1,1.16.028,1.719,1.719,0,0,1,1.282,1.155c.127.371.085.747.249,1.118a1.323,1.323,0,0,0,.672.676,1.659,1.659,0,0,0,1.334-.023Z",
    transform: "translate(-96.643 -158.245)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23600",
    "data-name": "Path 23600",
    d: "M150.879,221l-.009,0",
    transform: "translate(-139.151 -209.952)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23601",
    "data-name": "Path 23601",
    d: "M154.637,221.839a2.968,2.968,0,0,1-3.485-1.033",
    transform: "translate(-139.419 -209.773)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23602",
    "data-name": "Path 23602",
    d: "M136.873,201.531l.3-.061-.2.235.146.277-.272-.132-.2.235.033-.319-.277-.132.3-.061.033-.319",
    transform: "translate(-125.399 -191.198)",
    fill: "#ba0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sg",
    transform: "translate(90.224 29.591)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23604",
    "data-name": "Path 23604",
    d: "M-20,0H19.3V26.2H-20Z",
    transform: "translate(18.908)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23605",
    "data-name": "Path 23605",
    d: "M-20,0H19.3V13.1H-20Z",
    transform: "translate(18.908)",
    fill: "#df0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23606",
    "data-name": "Path 23606",
    d: "M42.9,37.067a4.606,4.606,0,0,0,.044,9.016,4.686,4.686,0,1,1-2.6-9.006,4.491,4.491,0,0,1,2.56-.011Z",
    transform: "translate(-34.931 -34.873)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23607",
    "data-name": "Path 23607",
    d: "M105.583,54.409l.267.819-.71-.5-.7.513.256-.83L104,53.9l.868-.011.273-.819.273.819h.862Zm.955,2.838.273.824-.71-.5-.7.508.262-.824-.7-.513.868-.005.267-.824.273.819h.873Zm3.193-.022.267.83-.71-.508-.7.508.256-.824-.7-.508.868-.011.273-.819.273.819h.862Zm.95-2.816.267.824-.71-.5-.7.508.262-.824-.7-.513.873-.005.262-.824.273.819h.873Zm-2.527-1.872.273.83-.71-.508-.7.513.262-.83-.7-.513.862-.005.273-.824.273.819h.873Z",
    transform: "translate(-98.324 -48.406)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect1);
export default __webpack_public_path__ + "static/media/collect_1.b98c116660be690a56b1783c97bfcd76.svg";
export { ForwardRef as ReactComponent };